import { render } from "./UserLeaderboard.vue?vue&type=template&id=705e611a&scoped=true"
import script from "./UserLeaderboard.vue?vue&type=script&lang=js"
export * from "./UserLeaderboard.vue?vue&type=script&lang=js"

import "./UserLeaderboard.vue?vue&type=style&index=0&id=705e611a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705e611a"]])

export default __exports__